var getButtonIconSize = function getButtonIconSize(size) {
  switch (size) {
    case "xs":
      return "xs";

    case "sm":
      return "sm";

    case "md":
    case "lg":
    default:
      return "md";
  }
};

export { getButtonIconSize };